import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { useQuery } from 'react-query';
import { OrganizationLicenseDto } from '../types';
import { OrganizationKeys } from './organization.keys';

export const getOrganizationLicenses = async (orgId: string) => {
  const response = await clients.admin.get(`/organizationlicenses/fororg/${orgId}`);
  return response.data as OrganizationLicenseDto[];
};

export const useGetOrganizationLicenses = (orgId: string | undefined) =>
  useQuery(
    OrganizationKeys.orgLicensesCollection(orgId?.toString() ?? ''),
    () => getOrganizationLicenses(orgId?.toString() ?? ''),
    {
      enabled: orgId !== undefined,
    },
  );
